import { Heading } from '@cinch-labs/design-system'
import { dashify } from '@cinch-labs/shared-util'
import { FAQSection, RichTextSection } from '@cinch-nx/data-storyblok'
import { StoryblokRenderer } from '@cinch-nx/landing-ui-shared'
import { storyblokComponents } from '../../data/storyblok-renderer-map'

import styles from './clause-section.module.css'

export type Props = {
  title: string
  body: (FAQSection | RichTextSection)[]
}

export const ClauseSection: React.FC<Props> = ({ title, body }) => (
  <section className={styles.container}>
    <Heading
      element="h2"
      className={styles.title}
      fontSize="h1"
      id={dashify(title)}
    >
      {title}
    </Heading>
    <StoryblokRenderer block={body} components={storyblokComponents} />
  </section>
)

export default ClauseSection
